import {NgModule} from '@angular/core';
import {AgGridModule} from 'ag-grid-angular';
import {ColliEventsComponent} from './colli-events.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { ColliInfoCellComponent } from './colli-info-cell/colli-info-cell.component';


@NgModule({
  declarations: [ColliEventsComponent, ColliInfoCellComponent],
  imports: [
    CollapseModule,
    AgGridModule,
    FontAwesomeModule
  ],
  exports: [ColliEventsComponent],
  entryComponents: [ColliInfoCellComponent]
})
export class ColliEventsModule {
}
